const SINGLE_TYPES = 'single-types';
const COLLECTION_TYPES = 'collection-types';

export { SINGLE_TYPES, COLLECTION_TYPES };
